module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_poland.1855c2e3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_poland.png
// module id = 1234
// module chunks = 16